import { Component } from '@angular/core';

@Component({
  selector: 'app-action-button-demo-api-spec',
  imports: [],
  templateUrl: './action-button-demo-api-spec.component.html',
  styleUrl: './action-button-demo-api-spec.component.scss',
})
export class ActionButtonDemoApiSpecComponent {}
